import { create } from 'zustand';
import type { AuthUser } from '../lib/privy';

type AuthActions = {
  /** Opens the Privy login modal (email OTP or Google). */
  signIn: () => void;
  /** Opens the Privy modal on the email step only. */
  signInWithEmail: () => void;
  /** Starts the Google OAuth redirect directly, skipping the modal. */
  signInWithGoogle: () => Promise<void>;
  signOut: () => Promise<void>;
};

/**
 * Auth state, mirrored from Privy by `<AuthBridge />` so any component can
 * read the current user without depending on Privy hooks directly.
 */
interface AuthState extends AuthActions {
  user: AuthUser | null;
  /** True until Privy has restored (or ruled out) an existing session. */
  loading: boolean;
  /** Internal: wired by AuthBridge. */
  _bind: (actions: AuthActions) => void;
  _sync: (state: { user: AuthUser | null; loading: boolean }) => void;
}

const notReady = () => console.warn('Auth not ready yet');

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  signIn: notReady,
  signInWithEmail: notReady,
  signInWithGoogle: async () => notReady(),
  signOut: async () => {},
  _bind: (actions) => set(actions),
  _sync: ({ user, loading }) => set({ user, loading }),
}));
